module.exports = __webpack_public_path__ + "img/m-users.78a0619a.svg";